import { render, staticRenderFns } from "./MarketingCourse.vue?vue&type=template&id=a7b1bd8a&scoped=true"
import script from "./MarketingCourse.vue?vue&type=script&lang=js"
export * from "./MarketingCourse.vue?vue&type=script&lang=js"
import style0 from "./MarketingCourse.vue?vue&type=style&index=0&id=a7b1bd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b1bd8a",
  null
  
)

export default component.exports